// ******************** Risks *************************
// GET
export const GET_RISK = "GET_RISK"
export const GET_RISK_SUCCESS = "GET_RISK_SUCCESS"
export const GET_RISK_NO_ARCHIVE = "GET_RISK_NO_ARCHIVE"
export const GET_RISK_NO_ARCHIVE_SUCCESS = "GET_RISK_NO_ARCHIVE_SUCCESS"
export const GET_RISK_BY_ID = "GET_RISK_BY_ID"
export const GET_RISK_BY_ID_SUCCESS = "GET_RISK_BY_ID_SUCCESS"
export const GET_RISK_BY_MAPPING_RISK_ID = "GET_RISK_BY_MAPPING_RISK_ID"
export const GET_RISK_BY_MAPPING_RISK_ID_SUCCESS = "GET_RISK_BY_MAPPING_RISK_ID_SUCCESS"
// SET
export const SET_LIST_RISK_ASSOCIATED = "SET_LIST_RISK_ASSOCIATED"
// POST
export const POST_RISK = "POST_RISK"
export const POST_RISK_SUCCESS = "POST_RISK_SUCCESS"
// PATCH
export const PATCH_RISK_BY_ID = "PATCH_RISK_BY_ID"
export const PATCH_RISK_BY_ID_SUCCESS = "PATCH_RISK_BY_ID_SUCCESS"
// DELETE
export const DELETE_RISK_BY_ID = "DELETE_RISK_BY_ID"
export const DELETE_RISK_BY_ID_SUCCESS = "DELETE_RISK_BY_ID_SUCCESS"
// ******************** Risks Residual *************************
// GET
export const GET_RISK_RESIDUAL = "GET_RISK_RESIDUAL"
export const GET_RISK_RESIDUAL_SUCCESS = "GET_RISK_RESIDUAL_SUCCESS"
export const GET_RISK_RESIDUAL_BY_ID = "GET_RISK_RESIDUAL_BY_ID"
export const GET_RISK_RESIDUAL_BY_ID_SUCCESS = "GET_RISK_RESIDUAL_BY_ID_SUCCESS"
// POST
export const POST_RISK_RESIDUAL = "POST_RISK_RESIDUAL"
export const POST_RISK_RESIDUAL_SUCCESS = "POST_RISK_RESIDUAL_SUCCESS"
// PATCH
export const PATCH_RISK_RESIDUAL_BY_ID = "PATCH_RISK_RESIDUAL_BY_ID"
export const PATCH_RISK_RESIDUAL_BY_ID_SUCCESS = "PATCH_RISK_RESIDUAL_BY_ID_SUCCESS"
// DELETE
export const DELETE_RISK_RESIDUAL_BY_ID = "DELETE_RISK_RESIDUAL_BY_ID"
export const DELETE_RISK_RESIDUAL_BY_ID_SUCCESS = "DELETE_RISK_RESIDUAL_BY_ID_SUCCESS"
// ************** Mapping Risks *************************
// GET
export const GET_MAPPING_RISK = "GET_MAPPING_RISK"
export const GET_MAPPING_RISK_SUCCESS = "GET_MAPPING_RISK_SUCCESS"
export const GET_MAPPING_RISK_BY_ID = "GET_MAPPING_RISK_BY_ID"
export const GET_MAPPING_RISK_BY_ID_SUCCESS = "GET_MAPPING_RISK_BY_ID_SUCCESS"
export const GET_HISTORIC_OF_MAPPING_RISK_BY_ID = "GET_HISTORIC_OF_MAPPING_RISK_BY_ID"
export const GET_HISTORIC_OF_MAPPING_RISK_BY_ID_SUCCESS =
  "GET_HISTORIC_OF_MAPPING_RISK_BY_ID_SUCCESS"
// POST
export const POST_MAPPING_RISK = "POST_MAPPING_RISK"
export const POST_MAPPING_RISK_SUCCESS = "POST_MAPPING_RISK_SUCCESS"
// PATCH
export const PATCH_MAPPING_RISK_BY_ID = "PATCH_MAPPING_RISK_BY_ID"
export const PATCH_MAPPING_RISK_BY_ID_SUCCESS = "PATCH_MAPPING_RISK_BY_ID_SUCCESS"
// POST
export const DELETE_MAPPING_RISK_BY_ID = "DELETE_MAPPING_RISK_BY_ID"
export const DELETE_MAPPING_RISK_BY_ID_SUCCESS = "DELETE_MAPPING_RISK_BY_ID_SUCCESS"
// ************** Matrice Risks *************************
// GET
export const GET_MATRICE_RISK = "GET_MATRICE_RISK"
export const GET_MATRICE_RISK_SUCCESS = "GET_MATRICE_RISK_SUCCESS"
export const GET_MATRICE_RISK_BY_ID = "GET_MATRICE_RISK_BY_ID"
export const GET_MATRICE_RISK_BY_ID_SUCCESS = "GET_MATRICE_RISK_BY_ID_SUCCESS"
export const GET_FRENQUENCIES_AND_IMPACTS = "GET_FRENQUENCIES_AND_IMPACTS"
export const GET_FRENQUENCIES_AND_IMPACTS_SUCCESS = "GET_FRENQUENCIES_AND_IMPACTS_SUCCESS"
export const GET_CALCUL_RISK_BRUT_RESULT = "GET_CALCUL_RISK_BRUT_RESULT"
export const GET_CALCUL_RISK_BRUT_RESULT_SUCCESS = "GET_CALCUL_RISK_BRUT_RESULT_SUCCESS"
// POST
export const POST_MATRICE_RISK = "POST_MATRICE_RISK"
export const POST_MATRICE_RISK_SUCCESS = "POST_MATRICE_RISK_SUCCESS"
// PATCH
export const PATCH_MATRICE_RISK_BY_ID = "PATCH_MATRICE_RISK_BY_ID"
export const PATCH_MATRICE_RISK_BY_ID_SUCCESS = "PATCH_MATRICE_RISK_BY_ID_SUCCESS"
//************************* Echelle de conformité ************************** */
// GET
export const GET_CONFORMITY_SCALE = "GET_CONFORMITY_SCALE"
export const GET_CONFORMITY_SCALE_SUCCESS = "GET_CONFORMITY_SCALE_SUCCESS"
export const GET_CONFORMITY_SCALE_BY_CONTROL = "GET_CONFORMITY_SCALE_BY_CONTROL"
export const GET_CONFORMITY_SCALE_BY_CONTROL_SUCCESS = "GET_CONFORMITY_SCALE_BY_CONTROL_SUCCESS"
// POST
export const POST_CONFORMITY_SCALE = "POST_CONFORMITY_SCALE"
export const POST_CONFORMITY_SCALE_SUCCESS = "POST_CONFORMITY_SCALE_SUCCESS"
